var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page", attrs: { type: "full" } },
    [
      _c(
        "d2-grid-layout",
        _vm._b(
          { on: { "layout-updated": _vm.layoutUpdatedHandler } },
          "d2-grid-layout",
          _vm.layout,
          false
        ),
        _vm._l(_vm.layout.layout, function(item, index) {
          return _c(
            "d2-grid-item",
            _vm._b(
              {
                key: index,
                on: {
                  resize: _vm.resizeHandler,
                  move: _vm.moveHandler,
                  resized: _vm.resizedHandler,
                  moved: _vm.movedHandler
                }
              },
              "d2-grid-item",
              item,
              false
            ),
            [
              _c(
                "el-card",
                { staticClass: "page_card", attrs: { shadow: "never" } },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: { slot: "header", size: "mini", type: "info" },
                      slot: "header"
                    },
                    [_vm._v("Card " + _vm._s(item.i))]
                  ),
                  item.i === "0"
                    ? [
                        _c("div", { staticClass: "d2-mb" }, [
                          _vm._v("拖拽卡片调整位置")
                        ]),
                        _c("div", { staticClass: "d2-mb" }, [
                          _vm._v("拖拽卡片右下角的手柄调整卡片大小")
                        ]),
                        _c("div", { staticClass: "d2-mb" }, [
                          _vm._v("在控制台打印出数据变化")
                        ])
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }